import React from 'react'
import { useEffect } from 'react';
import Swiper from 'swiper';
import SingleServicesImg1 from "../assets/images/services/single-services1.jpg"
import SingleServicesImg2 from "../assets/images/services/single-services2.jpg"
import SingleServicesImg3 from "../assets/images/services/single-services3.jpg"
import SingleProjectImgMain from '../assets/images/projects/single_project_img_main.jpg'
import SingleProjectGroupImg1 from '../assets/images/projects/single_project_group_img1.jpg'
import SingleProjectGroupImg2 from '../assets/images/projects/single_project_group_img2.jpg'
import SingleProjectGroupImg3 from '../assets/images/projects/single_project_group_img3.jpg'
import SingleProjectGroupImg4 from '../assets/images/projects/single_project_group_img4.jpg'
import FixHeader from '../component/FixHeader'
import Loader from '../component/Loader'
import LatestBlog from '../component/LatestBlog'
import Footer from '../component/Footer'
import { useNavigate } from 'react-router-dom';

const ProjectDetails3 = () => {
    const navigate = useNavigate()

    useEffect(() => {
        new Swiper(".single-slider", {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            speed: 1600,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }, []);
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="project-section-one" >
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Single Projects</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/ProjectDetails3")}>Projects</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/ProjectDetails3")}>Single Projects 3</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two pb-0">
                <div className="container">
                    <div className="row single-services3-row">
                        <div className="col-xxl-8 col-xl-8 col-lg-12 col-md-12">
                            <div className="swiper single-slider">
                                <div className="swiper-wrapper ">
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleProjectImgMain} alt="single-services1" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg1} alt="single-services1" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg2} alt="single-services2" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg3} alt="single-services3" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg1} alt="single-services1" />
                                    </div>
                                </div>
                            </div>
                            <h2 className="Singleservices-text-main">Homely Real Estate</h2>
                            <p className="commodo">Commodo semper bibendum adipiscing orci bibendum eu lectus sed. Commodo
                                cursus vitae augue luctus nibh. Congue sit quisque volutpat libero tempor a id cursus purus.
                                Pellentesque pellentesque scelerisque curabitur porta dolor. Amet vulputate vitae eget sit
                                rhoncus imperdiet. Odio justo nullam scelerisque quis bibendum. Cras ipsum vel diam praesent
                                tortor at elit sit. A risus molestie bibendum donec blandit adipiscing volutpat sollicitudin
                                aliquam. Nec arcu cras ultrices velit sed ligula. Iaculis elit vulputate sollicitudin
                                quisque ut faucibus.</p>
                            <p className="commodo pt-2">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus
                                vestibulum vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis
                                hac nisl dui facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet
                                vestibulum in magna aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non.
                            </p>
                            <div className="single-services-imgs-group">
                                <img src={SingleProjectGroupImg1} alt="SingleProjectGroupImg1" />
                                <img src={SingleProjectGroupImg2} alt="SingleProjectGroupImg2" />
                                <img src={SingleProjectGroupImg3} alt="SingleProjectGroupImg3" />
                                <img src={SingleProjectGroupImg4} alt="SingleProjectGroupImg4" />
                            </div>
                            <p className="commodo">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus vestibulum
                                vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis hac nisl dui
                                facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet vestibulum in magna
                                aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non. Elit sed magna
                                risus tempor non quis. Nec pulvinar scelerisque in faucibus.</p>
                            <p className="commodo pt-2">Dis morbi cursus aliquam rutrum tortor amet. Mauris consequat libero
                                praesent pellentesque nibh sed eget urna. Leo at feugiat vel dictum eget quam et commodo
                                nullam. Nec arcu egestas adipiscing mollis dapibus justo non.</p>
                            <div className="accordion" id="accordion2">
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqOne">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseOne">What is your review
                                            policy?
                                        </button>
                                    </div>
                                    <div id="faqcollapseOne" className="accordion-collapse collapse" aria-labelledby="faqOne"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem
                                            provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil,
                                            nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqTwo">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseTwo">What is the typical
                                            turnaround time for content?
                                        </button>
                                    </div>
                                    <div id="faqcollapseTwo" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqThree">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseThree">What types of
                                            content can I order?
                                        </button>
                                    </div>
                                    <div id="faqcollapseThree" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqFour">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseFour">Who are the Crowd
                                            Content writers?
                                        </button>
                                    </div>
                                    <div id="faqcollapseFour" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqFive">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseFive">How much does a
                                            website cost?
                                        </button>
                                    </div>
                                    <div id="faqcollapseFive" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqSix">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseSix">What happens if I
                                            don't like the content?
                                        </button>
                                    </div>
                                    <div id="faqcollapseSix" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil, nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <LatestBlog />
            <Footer />
        </>
    )
}
export default ProjectDetails3